import { apiClient, unwrap } from './client';
import type { Colleague, Task, TaskPriority, TaskStatus } from '@/types';

export interface CreateTaskPayload {
  title:        string;
  description?: string;
  priority?:    TaskPriority;
  dueDate?:     string;
}

export interface UpdateTaskPayload {
  title?:       string;
  description?: string;
  priority?:    TaskPriority;
  status?:      TaskStatus;
  dueDate?:     string;
  completed?:   boolean;
}

export interface AssignTaskPayload {
  userId:            string;
  targetFilialeKey?: string;
  title:             string;
  description?:      string;
  priority?:         TaskPriority;
  dueDate?:          string;
}

export const tasksApi = {
  list: async (): Promise<Task[]> => {
    const r = await apiClient.get('/me/tasks');
    return unwrap<Task[]>(r);
  },
  create: async (payload: CreateTaskPayload): Promise<Task> => {
    const r = await apiClient.post('/me/tasks', payload);
    return unwrap<Task>(r);
  },
  update: async (id: string, payload: UpdateTaskPayload): Promise<Task> => {
    const r = await apiClient.patch(`/me/tasks/${id}`, payload);
    return unwrap<Task>(r);
  },
  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/me/tasks/${id}`);
  },

  // ── Assignation hiérarchique ────────────────────────────
  listColleagues: async (): Promise<Colleague[]> => {
    const r = await apiClient.get('/me/colleagues');
    return unwrap<Colleague[]>(r);
  },
  assign: async (payload: AssignTaskPayload): Promise<Task> => {
    const r = await apiClient.post('/tasks/assign', payload);
    return unwrap<Task>(r);
  },
  listAssignedByMe: async (): Promise<Task[]> => {
    const r = await apiClient.get('/tasks/assigned-by-me');
    return unwrap<Task[]>(r);
  },
};
